module.exports = __webpack_public_path__ + "static/media/20190808_133850.35172d07.png";